import * as THREE from 'three';
import vertexShader from '../shaders/terrain.vert';
import fragmentShader from '../shaders/terrain.frag';

// Point cloud material with custom shaders
export const pointMaterial = new THREE.ShaderMaterial({
  uniforms: {
    uMap: { value: null },
    uScale: { value: 2.8 },
    uBias: { value: -2.8 * 0.5 },
    uColor: { value: new THREE.Color(0x8a8f9a) },
    uPointSize: { value: 2.0 },
    uTime: { value: 0.0 },
    uJitter: { value: 0.02 },
    uMaskCenter: { value: new THREE.Vector2(0.0, 0.0) },
    uMaskRadius: { value: 4.0 },
    uMaskFeather: { value: 0.6 },
    uHoverCenter: { value: new THREE.Vector2(9999.0, 9999.0) },
    uHoverRadius: { value: 1.6 },
    uHoverStrength: { value: 0.8 },
    uHoverSnap: { value: 2.0 },
    uHoverColor: { value: new THREE.Color(0xffcc55) },
    uHoverEnabled: { value: 1.0 },
    // Airplane hover highlight
    uAirplanePos: { value: new THREE.Vector3(9999, 9999, 9999) },
    uAirplaneHoverEnabled: { value: 0.0 },
    uAirplaneHoverRadius: { value: 2.0 },
    // Radar pulse
    uRadarActive: { value: 0.0 },
    uRadarOrigin: { value: new THREE.Vector3(0, 0, 0) },
    uRadarRadius: { value: 0.0 },
    uRadarRingWidth: { value: 0.6 },
    uRadarFade: { value: 1.0 },
    // Radar rain animation
    uRadarRainHeight: { value: 41.0 },     // How high particles start above final position
    uRadarRainDuration: { value: 0.35 },   // How long the fall animation takes (seconds)
    uRadarTime: { value: 0.0 },            // Current time since radar started
    uRadarExpandSpeed: { value: 9.72 },    // Units per second for ring expansion
    uRadarShowRing: { value: 0.0 },        // Whether to show the colored ring effect
    uRadarPermanent: { value: 0.0 },       // Whether ring coloring is permanently enabled
    uRadarRingFeather: { value: 0.1 },     // Softness of the ring edges
    uPersistentRevealRadius: { value: 0.0 }, // Tracks max revealed area (doesn't reset on new pulse)
    // Rain and ring colors
    uRainColor: { value: new THREE.Color(0x9dc4cc) },           // Color of falling particles
    uRadarRingColorLow: { value: new THREE.Color(0x00ccff) },   // Ring color for valleys
    uRadarRingColorMid: { value: new THREE.Color(0x00ff80) },   // Ring color for mid
    uRadarRingColorHigh: { value: new THREE.Color(0xffee33) },  // Ring color for peaks
    uRainColorFadeDuration: { value: 1.0 },                      // Time to crossfade from rain to ring color
    // Rain particle shape
    uRainParticleWidth: { value: 0.01 },
    uRainParticleLength: { value: 2.0 },
    uRainImpactScale: { value: 4.0 },
    uRainSpawnRadius: { value: 5 },  // How close to center particles originate (0 = exact center)
    uAirplaneColorFar: { value: new THREE.Color(0x00dfff) },  // cyan when high/safe
    uAirplaneColorClose: { value: new THREE.Color(0xff0000) }, // red when low/danger
    // Fog uniforms expected by renderer when material.fog === true
    fogColor: { value: new THREE.Color(0x0e0f13) },
    fogNear: { value: 1 },
    fogFar: { value: 1000 },
    fogDensity: { value: 0.00025 }
  },
  transparent: true,
  depthWrite: true,
  blending: THREE.NormalBlending,
  fog: true,
  vertexShader,
  fragmentShader
});

// Enable UV chunks in shader includes
pointMaterial.defines = pointMaterial.defines || {};
pointMaterial.defines.USE_UV = '';
